import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useQuery } from '@tanstack/react-query';

import Sidebar from '../../feature/Sidebar';
import loadingState from '../../stores/atoms/loadingAtom';
import Loading from '../../components/Loading';
import TwilioWidget from '../../feature/Twilio';
import sidebarState from '../../stores/atoms/sidebarAtom';
import { GetUserProfile } from '../../services/User';
import query from '../../constants/queries';

const MainLayout = () => {
    const { data: user } = useQuery([query.userProfile], () => GetUserProfile());
    const showLoading = useRecoilValue(loadingState);
    const sidebarOpen = useRecoilValue(sidebarState);

    return (
        <div className="flex gap-1 h-page p-1">
            {showLoading && <Loading />}
            <Sidebar />
            <Box
                component="main"
                sx={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    marginLeft: `${sidebarOpen ? '244px' : '72px'}`,
                    padding: 0,
                    marginTop: 0,
                    height: '100%',
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    transition: 'cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    width: `${sidebarOpen ? 'calc(100vw - 244px)' : 'calc(100vw - 56px)'}`
                }}
            >
                <Outlet />
            </Box>
            {/* TODO: remove flag when all users have access to Twilio */}
            {user?.can_use_twilio && <TwilioWidget />}
        </div>
    );
};

export default MainLayout;
